/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Storage_Legajox_StatusInputs */

const es_settings_storage_legajox_status = /** @type {(inputs: Settings_Storage_Legajox_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrado`)
};

const en_settings_storage_legajox_status = /** @type {(inputs: Settings_Storage_Legajox_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrated`)
};

/**
* | output |
* | --- |
* | "Integrated" |
*
* @param {Settings_Storage_Legajox_StatusInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_storage_legajox_status = /** @type {((inputs?: Settings_Storage_Legajox_StatusInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Storage_Legajox_StatusInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_storage_legajox_status(inputs)
	return en_settings_storage_legajox_status(inputs)
});
export { settings_storage_legajox_status as "settings.storage.legajox_status" }